import { render, staticRenderFns } from "./demenagement-de.vue?vue&type=template&id=85b99a6a"
import script from "./demenagement-de.vue?vue&type=script&lang=js"
export * from "./demenagement-de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports